module.exports = __webpack_public_path__ + "static/media/1_Connect-Phone-to-Wifi-b.f7d620aa.svg";